export default __webpack_public_path__ + "static/02_discovery-38d97c7a8717d1d5c0765eed4b34258f.mp4";